import React, { useState } from 'react'
import { useForm } from 'react-hook-form'

// // Components
import FieldError from '../fieldError'
import FileDrop from '../fileDrop'

const Selling = () => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors }
  } = useForm()
  const [files, setFiles] = useState([])
  const [submitting, setSubmitting] = useState(false)
  const [submittingComplete, setSubmittingComplete] = useState(false)

  const onSubmit = async (data) => {
    setSubmitting(true)

    const formData = new FormData()

    // Append other form data fields
    for (const key of Object.keys(data)) {
      if (key !== 'files') {
        formData.append(key, data[key])
      }
    }

    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append('files', file, file.name) // Append each file individually
      })
    }

    try {
      const response = await fetch('/.netlify/functions/postImagesToMonday', {
        method: 'POST',
        body: formData
      })

      if (!response.ok) {
        throw new Error('Failed to submit form data')
      }

      const responseData = await response.json()
      console.log('Response from Lambda function:', responseData)
      setSubmitting(false)
      setSubmittingComplete(true)
    } catch (error) {
      console.error('Error submitting form data:', error)
      setError('files', { type: 'custom', message: error.message })
      setSubmitting(false)
    }
  }
  return submittingComplete ? (
    <div className='mx-auto w-full max-w-screen-xl'>
      <div className='border-l-4 border-green-400 bg-green-50 p-10'>
        <div className='flex'>
          <div className='ml-3'>
            <div className='mb-2 text-5xl'>Success!</div>
            <p className='text-xl text-green-700 '>Thank you for submitting your item to us, we will be in touch within 48 hours.</p>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <form name='Item Entry' method='post' onSubmit={handleSubmit(onSubmit)}>
      <fieldset className='flex flex-col gap-3 lg:p-12 p-6 bg-white shadow-md'>
        <div>
          <label className='sr-only' htmlFor='email'>
            Email address
          </label>
          <div>
            <input
              className={`form-input ${errors.email ? 'input-error' : ''}`}
              id='email'
              name='email'
              type='email'
              autoComplete='email'
              placeholder='Email address'
              {...register('email', { required: true })}
            />
            {errors.email && <FieldError error={errors.email} />}
          </div>
        </div>
        <div>
          <label className='sr-only' htmlFor='first-name'>
            First Name
          </label>
          <div>
            <input
              className={`form-input ${errors['first name'] ? 'input-error' : ''}`}
              id='first-name'
              name='first-name'
              type='text'
              autoComplete='given-name'
              placeholder='First Name'
              {...register('first name', { required: true })}
            />
            {errors['first name'] && <FieldError error={errors['first name']} />}
          </div>
        </div>
        <div>
          <label className='sr-only' htmlFor='last-name'>
            Last Name
          </label>
          <div>
            <input
              className={`form-input ${errors['last name'] ? 'input-error' : ''}`}
              id='last-name'
              name='last-name'
              type='text'
              autoComplete='family-name'
              placeholder='Last Name'
              {...register('last name', { required: true })}
            />
            {errors['last name'] && <FieldError error={errors['last name']} />}
          </div>
        </div>
        <div>
          <label className='sr-only' htmlFor='company-name'>
            Company Name
          </label>
          <div>
            <input
              className={`form-input ${errors['company name'] ? 'input-error' : ''}`}
              id='company-name'
              name='company-name'
              type='text'
              autoComplete='organization'
              placeholder='Company Name'
              {...register('company name', { required: true })}
            />
            {errors['company name'] && <FieldError error={errors['company name']} />}
          </div>
        </div>
        {/* <div>
          <label className='sr-only' htmlFor='country'>
            Country
          </label>
          <div>
            <input
              className={`form-input ${errors.country ? 'input-error' : ''}`}
              id='country'
              name='country'
              type='text'
              autoComplete='country'
              placeholder='Country'
              {...register('country', { required: true })}
            />
            {errors.country && <FieldError error={errors.country} />}
          </div>
        </div> */}
        <div>
          <label htmlFor='phone-number' className='sr-only'>
            Phone Number
          </label>
          <div className='flex flex-row gap-4'>
            <div className='w-1/3'>
              <select
                defaultValue=''
                className={`form-input ${errors['country code'] ? 'input-error' : ''}`}
                name='country-code'
                id='country-code'
                {...register('country code', { required: true, validate: (value) => value !== '' })}>
                <option value='' disabled>
                  Select Country
                </option>
                <option value='GB'>United Kingdom</option>
                <option value='US'>United States</option>
                <option value='AL'>Albania</option>
                <option value='DZ'>Algeria</option>
                <option value='AS'>American Samoa</option>
                <option value='AD'>Andorra</option>
                <option value='AO'>Angola</option>
                <option value='AI'>Anguilla</option>
                <option value='AQ'>Antarctica</option>
                <option value='AG'>Antigua and Barbuda</option>
                <option value='AR'>Argentina</option>
                <option value='AM'>Armenia</option>
                <option value='AW'>Aruba</option>
                <option value='AU'>Australia</option>
                <option value='AT'>Austria</option>
                <option value='AZ'>Azerbaijan</option>
                <option value='BS'>Bahamas</option>
                <option value='BH'>Bahrain</option>
                <option value='BD'>Bangladesh</option>
                <option value='BB'>Barbados</option>
                <option value='BY'>Belarus</option>
                <option value='BE'>Belgium</option>
                <option value='BZ'>Belize</option>
                <option value='BJ'>Benin</option>
                <option value='BM'>Bermuda</option>
                <option value='BT'>Bhutan</option>
                <option value='BO'>Bolivia</option>
                <option value='BQ'>Bonaire, Saint Eustatius and Saba</option>
                <option value='BA'>Bosnia and Herzegovina</option>
                <option value='BW'>Botswana</option>
                <option value='BV'>Bouvet Island</option>
                <option value='BR'>Brazil</option>
                <option value='IO'>British Indian Ocean Territory</option>
                <option value='VG'>British Virgin Islands</option>
                <option value='BN'>Brunei</option>
                <option value='BG'>Bulgaria</option>
                <option value='BF'>Burkina Faso</option>
                <option value='BI'>Burundi</option>
                <option value='KH'>Cambodia</option>
                <option value='CM'>Cameroon</option>
                <option value='CA'>Canada</option>
                <option value='CV'>Cape Verde</option>
                <option value='KY'>Cayman Islands</option>
                <option value='CF'>Central African Republic</option>
                <option value='TD'>Chad</option>
                <option value='CL'>Chile</option>
                <option value='CN'>China</option>
                <option value='CX'>Christmas Island</option>
                <option value='CC'>Cocos Islands</option>
                <option value='CO'>Colombia</option>
                <option value='KM'>Comoros</option>
                <option value='CG'>Republic of the Congo</option>
                <option value='CD'>Democratic Republic of the Congo</option>
                <option value='CK'>Cook Islands</option>
                <option value='CR'>Costa Rica</option>
                <option value='HR'>Croatia</option>
                <option value='CU'>Cuba</option>
                <option value='CW'>Curacao</option>
                <option value='CY'>Cyprus</option>
                <option value='CZ'>Czech Republic</option>
                <option value='DK'>Denmark</option>
                <option value='DJ'>Djibouti</option>
                <option value='DM'>Dominica</option>
                <option value='DO'>Dominican Republic</option>
                <option value='TL'>East Timor</option>
                <option value='EC'>Ecuador</option>
                <option value='EG'>Egypt</option>
                <option value='SV'>El Salvador</option>
                <option value='GQ'>Equatorial Guinea</option>
                <option value='ER'>Eritrea</option>
                <option value='EE'>Estonia</option>
                <option value='ET'>Ethiopia</option>
                <option value='FK'>Falkland Islands</option>
                <option value='FO'>Faroe Islands</option>
                <option value='FJ'>Fiji</option>
                <option value='FI'>Finland</option>
                <option value='FR'>France</option>
                <option value='GF'>French Guiana</option>
                <option value='PF'>French Polynesia</option>
                <option value='TF'>French Southern Territories</option>
                <option value='GA'>Gabon</option>
                <option value='GM'>Gambia</option>
                <option value='GE'>Georgia</option>
                <option value='DE'>Germany</option>
                <option value='GH'>Ghana</option>
                <option value='GI'>Gibraltar</option>
                <option value='GR'>Greece</option>
                <option value='GL'>Greenland</option>
                <option value='GD'>Grenada</option>
                <option value='GP'>Guadeloupe</option>
                <option value='GU'>Guam</option>
                <option value='GT'>Guatemala</option>
                <option value='GG'>Guernsey</option>
                <option value='GN'>Guinea</option>
                <option value='GW'>Guinea-Bissau</option>
                <option value='GY'>Guyana</option>
                <option value='HT'>Haiti</option>
                <option value='HM'>Heard Island and McDonald Islands</option>
                <option value='HN'>Honduras</option>
                <option value='HK'>Hong Kong</option>
                <option value='HU'>Hungary</option>
                <option value='IS'>Iceland</option>
                <option value='IN'>India</option>
                <option value='ID'>Indonesia</option>
                <option value='IR'>Iran</option>
                <option value='IQ'>Iraq</option>
                <option value='IE'>Ireland</option>
                <option value='IM'>Isle of Man</option>
                <option value='IL'>Israel</option>
                <option value='IT'>Italy</option>
                <option value='CI'>Ivory Coast</option>
                <option value='JM'>Jamaica</option>
                <option value='JP'>Japan</option>
                <option value='JE'>Jersey</option>
                <option value='JO'>Jordan</option>
                <option value='KZ'>Kazakhstan</option>
                <option value='KE'>Kenya</option>
                <option value='KI'>Kiribati</option>
                <option value='XK'>Kosovo</option>
                <option value='KW'>Kuwait</option>
                <option value='KG'>Kyrgyzstan</option>
                <option value='LA'>Laos</option>
                <option value='LV'>Latvia</option>
                <option value='LB'>Lebanon</option>
                <option value='LS'>Lesotho</option>
                <option value='LR'>Liberia</option>
                <option value='LY'>Libya</option>
                <option value='LI'>Liechtenstein</option>
                <option value='LT'>Lithuania</option>
                <option value='LU'>Luxembourg</option>
                <option value='MO'>Macao</option>
                <option value='MK'>North Macedonia</option>
                <option value='MG'>Madagascar</option>
                <option value='MW'>Malawi</option>
                <option value='MY'>Malaysia</option>
                <option value='MV'>Maldives</option>
                <option value='ML'>Mali</option>
                <option value='MT'>Malta</option>
                <option value='MH'>Marshall Islands</option>
                <option value='MQ'>Martinique</option>
                <option value='MR'>Mauritania</option>
                <option value='MU'>Mauritius</option>
                <option value='YT'>Mayotte</option>
                <option value='MX'>Mexico</option>
                <option value='FM'>Micronesia</option>
                <option value='MD'>Moldova</option>
                <option value='MC'>Monaco</option>
                <option value='MN'>Mongolia</option>
                <option value='ME'>Montenegro</option>
                <option value='MS'>Montserrat</option>
                <option value='MA'>Morocco</option>
                <option value='MZ'>Mozambique</option>
                <option value='MM'>Myanmar</option>
                <option value='NA'>Namibia</option>
                <option value='NR'>Nauru</option>
                <option value='NP'>Nepal</option>
                <option value='NL'>Netherlands</option>
                <option value='AN'>Netherlands Antilles</option>
                <option value='NC'>New Caledonia</option>
                <option value='NZ'>New Zealand</option>
                <option value='NI'>Nicaragua</option>
                <option value='NE'>Niger</option>
                <option value='NG'>Nigeria</option>
                <option value='NU'>Niue</option>
                <option value='NF'>Norfolk Island</option>
                <option value='KP'>North Korea</option>
                <option value='MP'>Northern Mariana Islands</option>
                <option value='NO'>Norway</option>
                <option value='OM'>Oman</option>
                <option value='PK'>Pakistan</option>
                <option value='PW'>Palau</option>
                <option value='PS'>Palestinian Territory</option>
                <option value='PA'>Panama</option>
                <option value='PG'>Papua New Guinea</option>
                <option value='PY'>Paraguay</option>
                <option value='PE'>Peru</option>
                <option value='PH'>Philippines</option>
                <option value='PN'>Pitcairn</option>
                <option value='PL'>Poland</option>
                <option value='PT'>Portugal</option>
                <option value='PR'>Puerto Rico</option>
                <option value='QA'>Qatar</option>
                <option value='CG'>Republic of the Congo</option>
                <option value='RE'>Reunion</option>
                <option value='RO'>Romania</option>
                <option value='RU'>Russia</option>
                <option value='RW'>Rwanda</option>
                <option value='BL'>Saint Barthelemy</option>
                <option value='SH'>Saint Helena</option>
                <option value='KN'>Saint Kitts and Nevis</option>
                <option value='LC'>Saint Lucia</option>
                <option value='MF'>Saint Martin</option>
                <option value='PM'>Saint Pierre and Miquelon</option>
                <option value='VC'>Saint Vincent and the Grenadines</option>
                <option value='WS'>Samoa</option>
                <option value='SM'>San Marino</option>
                <option value='ST'>Sao Tome and Principe</option>
                <option value='SA'>Saudi Arabia</option>
                <option value='SN'>Senegal</option>
                <option value='RS'>Serbia</option>
                <option value='SC'>Seychelles</option>
                <option value='SL'>Sierra Leone</option>
                <option value='SG'>Singapore</option>
                <option value='SX'>Sint Maarten</option>
                <option value='SK'>Slovakia</option>
                <option value='SI'>Slovenia</option>
                <option value='SB'>Solomon Islands</option>
                <option value='SO'>Somalia</option>
                <option value='ZA'>South Africa</option>
                <option value='GS'>South Georgia and the South Sandwich Islands</option>
                <option value='KR'>South Korea</option>
                <option value='SS'>South Sudan</option>
                <option value='ES'>Spain</option>
                <option value='LK'>Sri Lanka</option>
                <option value='SD'>Sudan</option>
                <option value='SR'>Suriname</option>
                <option value='SJ'>Svalbard and Jan Mayen</option>
                <option value='SZ'>Swaziland</option>
                <option value='SE'>Sweden</option>
                <option value='CH'>Switzerland</option>
                <option value='SY'>Syria</option>
                <option value='TW'>Taiwan</option>
                <option value='TJ'>Tajikistan</option>
                <option value='TZ'>Tanzania</option>
                <option value='TH'>Thailand</option>
                <option value='TG'>Togo</option>
                <option value='TK'>Tokelau</option>
                <option value='TO'>Tonga</option>
                <option value='TT'>Trinidad and Tobago</option>
                <option value='TN'>Tunisia</option>
                <option value='TR'>Turkey</option>
                <option value='TM'>Turkmenistan</option>
                <option value='TC'>Turks and Caicos Islands</option>
                <option value='TV'>Tuvalu</option>
                <option value='UG'>Uganda</option>
                <option value='UA'>Ukraine</option>
                <option value='AE'>United Arab Emirates</option>
                <option value='UM'>United States Minor Outlying Islands</option>
                <option value='VI'>U.S. Virgin Islands</option>
                <option value='UY'>Uruguay</option>
                <option value='UZ'>Uzbekistan</option>
                <option value='VU'>Vanuatu</option>
                <option value='VA'>Vatican</option>
                <option value='VE'>Venezuela</option>
                <option value='VN'>Vietnam</option>
                <option value='WF'>Wallis and Futuna</option>
                <option value='EH'>Western Sahara</option>
                <option value='YE'>Yemen</option>
                <option value='ZM'>Zambia</option>
                <option value='ZW'>Zimbabwe</option>
              </select>
              {errors['country code'] && <FieldError error={errors['country code']} />}
            </div>
            <div className='w-2/3'>
              <input
                className={`form-input ${errors['phone number'] ? 'input-error' : ''}`}
                id='phone-number'
                name='phone-number'
                type='tel'
                placeholder='Phone Number'
                autoComplete='tel'
                {...register('phone number', { required: true })}
              />
              {errors['phone number'] && <FieldError error={errors['phone number']} />}
            </div>
          </div>
        </div>
        <div>
          <label className='sr-only' htmlFor='details'>
            Details of Assets For Sale
          </label>
          <div>
            <textarea
              className={`form-input ${errors.details ? 'input-error' : ''}`}
              id='details'
              name='details'
              placeholder='Details of Assets For Sale'
              {...register('details', { required: true })}
            />
            {errors.details && <FieldError error={errors.details} />}
          </div>
        </div>
        <div>
          <label className='sr-only' htmlFor='reason'>
            Reason for sale
          </label>
          <div>
            <select
              defaultValue=''
              className={`form-input ${errors.reason ? 'input-error' : ''}`}
              id='reason'
              name='reason'
              {...register('reason', { required: true, validate: (value) => value !== '' })}>
              <option value='' disabled>
                Reason for sale
              </option>
              <option>Upgrading existing assets</option>
              <option>Surplus to requirements</option>
              <option>Liquidation of assets</option>
              <option>Business closing</option>
              <option>Other</option>
            </select>
            {errors.reason && <FieldError error={errors.reason} />}
          </div>
        </div>
        <div className='flex gap-3 flex-col'>
          <label className='font-bold text-xl' htmlFor='pictures'>
            Photos
          </label>
          <ul className='list-disc pl-6 space-y-1'>
            <li>You can upload up to 100MB of images in total.</li>
            <li>No single image can be more than 5MB</li>
            <li>Images must be JPG, JPEG or PNG.</li>
          </ul>
          <FileDrop name='files' setFiles={setFiles} files={files} {...register('files')} />
          {errors.files && <FieldError error={errors.files} />}
        </div>
        {submitting ? (
          <div className='text-stone-700'>
            {files && files.length > 0 ? (
              <div className='flex'>
                <svg className='animate-spin -ml-1 mr-3 h-5 w-5 text-brand-blue' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
                  <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
                  <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z' />
                </svg>
                Uploading images...
              </div>
            ) : (
              <span>Sending...</span>
            )}
          </div>
        ) : (
          <button type='submit' className='button button-primary w-full sm:w-auto'>
            Submit your asset
          </button>
        )}
      </fieldset>
    </form>
  )
}

export default React.memo(Selling)
